// extracted by mini-css-extract-plugin
export default {"actions":"ConfirmWithForm__actions___EOYMU"};